module.exports = __webpack_public_path__ + "static/16-2-e8be66cb09305f5fdfb3891d65b8031f.jpg";